import React, {useEffect, useState} from 'react';
import Api from '../../../../interface/api/visit';
import VisitChart from "../../../../component/visit-chart";


export default function VisitorDashBoard() {
    // 최근 6개월 정보
    let _arr = new Array();
    const [ monthList , setMonthList ] = useState<Object>();

    // 방문 신청 현황
    const [ dayilyVisitorApplicationInfo, setDayilyVisitorApplicationInfo ] = useState<Object>();

    // 승인 대기자 현황
    const [ dayilyVisitorApprove, setDayilyVisitorApprove ] = useState<Object>();

    // 입문 현황
    const [ dayilyVisitorIn, setDayilyVisitorIn ] = useState<Object>()

    // 출문 현황
    const [ dayilyVisitorOut, setDayilyVisitorOut ] = useState<Object>();

    // 월간 방문신청 통계
    const [ m_visitorApplicationInfo, setM_visitorApplicationInfo ] = useState<Object>();

    // 월간 방문객 통계
    const [ m_visitorInfo, setM_visitorInfo ] = useState<Object>();

    useEffect(() => {
        let siteInfo = JSON.parse(localStorage.getItem('siteInfo'));

        // 최근 6개월 정보 구하기
        let idx = 0;
        for(let i = 6; i > 0; i--) {
            _arr[idx] = {"label" : new Date(new Date().setMonth(new Date().getMonth() - i + 1)).getMonth() + 1 + "월"};
            idx++;
        }
        setMonthList(_arr);

        // dayily 현황 조회
        Api.getDayilyVisitorInfo(siteInfo.seq).then(res => {
            setDayilyVisitorApplicationInfo(res.data.dayilyVisitorApplicationInfo);
            setDayilyVisitorApprove(res.data.dayilyVisitorApprove);
            setDayilyVisitorIn(res.data.dayilyVisitorIn);
            setDayilyVisitorOut(res.data.dayilyVisitorOut);
        });

        // 월간 통계 조회
        Api.getVisitorChartInfo(siteInfo.seq).then(res => {
            setM_visitorApplicationInfo(res.data.mVisitorApplicationInfo);
            setM_visitorInfo(res.data.mVisitorInfo);
        });


    }, [])

    return (
        <>
            <div>
                <div>
                    <ul className="nv_visitoer_info">
                        <li>
                            <h4>방문 신청 현황<span className="info_detail"></span></h4>
                            <p><span className="nv_blue nv_bold" id="visitorApplicationCount_total">{dayilyVisitorApplicationInfo}</span>명</p>
                        </li>
                        <li>
                            <h4>승인 대기 현황<span className="info_detail"></span></h4>
                            <p><span className="nv_blue nv_bold" id="visitorStandbyCount_total">{dayilyVisitorApprove}</span>명</p>
                        </li>
                        <li>
                            <h4>입문 현황<span className="info_detail"></span></h4>
                            <p><span className="nv_blue nv_bold" id="visitorApproveCount_total">{dayilyVisitorIn}</span>명</p>
                        </li>
                        <li>
                            <h4>출문 현황<span className="info_detail"></span></h4>
                            <p><span className="nv_blue nv_bold" id="visitorCount_total">{dayilyVisitorOut}</span>명</p>
                        </li>
                    </ul>
                </div>
            </div>
            <VisitChart
                monthList = { monthList }
                m_visitorApplicationInfo = { m_visitorApplicationInfo }
                m_visitorInfo = { m_visitorInfo }
            />
        </>
    )
}
